/**
 * Gap between a header's eyebrow and its serif title (11px), as on the drawer headers. Shared so
 * cards that stack an eyebrow over a title (the Order Processing card) follow the drawer header
 * if it changes (TK-13316). Apply to a flex column holding the eyebrow and the title.
 */
export const HEADER_EYEBROW_TITLE_GAP_CLASS = 'gap-2.75'
